import React, {Component} from 'react'
import {Button} from "antd"
import {exportItemJson} from "../../../../services/api/3dApi"

class ExportBatch extends Component {
    _handleClick = () => {
        const {match, status} = this.props
        window.open(exportItemJson(match.params.id, `status=${status}`))
    }

    render() {
        const {changeContent} = this.props

        return (
            <Button icon='cloud-download' className="mr-3 mt-2"
                    onClick={this._handleClick}
                    disabled={changeContent}>
                Xuất Json
            </Button>
        )
    }

}

export default ExportBatch
